const AuthenticationTypes = {
  OAUTH: "oauth",
  BASIC: "basic_auth",
  ANY: "any",
};

export default AuthenticationTypes;
